import { stringify } from "qs";

export class ResidentClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/residents`;
  }

  async list() {
    const url = `${this.baseURL}/data`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/projects/${id}/homes`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getReport(type, dateTime) {
    const queryString = stringify(dateTime, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/${type}/report${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }
}
